<div class="mech-diag-content">
	<app-dvs-chart [error]="errormessage" [options]="spectrumoptions"></app-dvs-chart>
</div>